import script from "./ForbiddenPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ForbiddenPage.vue?vue&type=script&setup=true&lang=js"

import "./ForbiddenPage.vue?vue&type=style&index=0&id=56bda033&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56bda033"]])

export default __exports__